module.exports = __webpack_public_path__ + "assets/imgs/logos/reddit.22927d2836f287fb9ac8f0ef53e1989b.svg";